import { Message } from "../message.model";

export type BodyDailyAverageByHour =
  | {
      Tipo_consulta_BD: 'RANGO_MESES';
      mes_inicial: string;
      mes_final: string;
      sector: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'RANGO_DIAS';
      fecha_inicial: string;
      fecha_final: string;
      sector: string;
      sucursal: string;
      por_defecto?: string;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ACTUAL';
      anio_actual: string;
      sector: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'ANIO_ANTERIOR';
      anio_anterior: string;
      sector: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'MES_ACTUAL';
      mes_actual: string;
      sector: string;
      sucursal: string;
    }
  | {
      Tipo_consulta_BD: 'MES_ANTERIOR';
      mes_anterior: string;
      sector: string;
      sucursal: string;
    };

export interface ResponseDailyAverageByHour {
  column_name: ColumnNameDailyAverageByHour | Message;
}

export interface ColumnNameDailyAverageByHour {
  "public data": DataDailyAverageByHour[];
}

export interface DataDailyAverageByHour {
  Hora:      number;
  Lunes:     number;
  Martes:    number;
  Miercoles: number;
  Jueves:    number;
  Viernes:   number;
  Sabado:    number;
  Domingo:   number;
}


